<template>
  <div>
    <ml-table bordered :data-source="dataSource" :columns="columns" :scroll="{x: 1900}">
      <template slot="actions" slot-scope="text, record">
        <a-popconfirm
          v-if="dataSource.length"
          :title="$t('page_mdc_setting_sure_delete')"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">{{ $t('delete') }}</a>
        </a-popconfirm>
      </template>
      <template slot="material" slot-scope="text, record">
        <a-select
          show-search
          optionFilterProp="children"
          :value="record.materialName"
          style="width: 100%"
          :filter-option="false"
          :not-found-content="fetching ? undefined : null"
          @search="fetchUser"
          @change="(e) => handleChange(e, record.key, 'material')"
        >
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="item in materialList" :key="item.selctName">
            {{ item.selctName }}
          </a-select-option>
        </a-select>
      </template>
      <template slot="stockOutNum" slot-scope="text, record">
        <a-input-number
          :value="text"
          :min="0"
          :max="9999999"
          @change="(e) => handleChange(e, record.key, 'stockOutNum')"
          style="width: 100%;"
        ></a-input-number>
      </template>
      <template slot="issue" slot-scope="text, record">
        <a-select
          v-if="Number(text) != 2"
          show-search
          style="width:100%"
          :value="record.issue"
          @change="(value) => onChangeIssue(value, record.key)"
        >
          <a-select-option :value="0">
            {{ $t('yes') }}
          </a-select-option>
          <a-select-option :value="1">
            {{ $t('no') }}
          </a-select-option>
        </a-select>
      </template>
    </ml-table>
    <a-button type="primary" style="width: 100%;margin-top: 8px;" @click="handleAdd">{{
      $t('page_plan_maintenance_add_spare_parts')
    }}</a-button>
  </div>
</template>

<script>
import { WarehouseMaterialStockServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
const wmsp = new WarehouseMaterialStockServiceProxy()

const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    ellipsis: true,
    width: 100,
    scopedSlots: { customRender: 'actions' }
  },
  {
    title: 'page_material_ware_out_code',
    dataIndex: 'orderCode',
    key: 'orderCode',
    width: 200,
    scopedSlots: { customRender: 'orderCode' }
  },
  {
    title: 'page_business_material_property_spare_parts',
    dataIndex: 'materialId',
    key: 'materialId',
    width: 200,
    scopedSlots: { customRender: 'material' }
  },
  {
    title: 'page_material_check_area',
    dataIndex: 'areaName',
    width: 200,
    ellipsis: true
  },
  {
    title: 'page_material_check_location',
    dataIndex: 'locationName',
    width: 200,
    ellipsis: true
  },
  {
    title: 'page_plan_total_inventory',
    dataIndex: 'stockSumNum',
    key: 'stockSumNum',
    width: 200,
    scopedSlots: { customRender: 'stockSumNum' }
  },
  {
    title: 'page_tpm_record_table_location_num',
    dataIndex: 'locationNum',
    key: 'locationNum',
    width: 200,
    scopedSlots: { customRender: 'locationNum' }
  },
  {
    title: 'page_plan_delivery_quantity',
    dataIndex: 'stockOutNum',
    key: 'stockOutNum',
    width: 200,
    scopedSlots: { customRender: 'stockOutNum' }
  },
  {
    title: 'page_tpm_record_table_issue',
    dataIndex: 'issue',
    key: 'issue',
    width: 200,
    scopedSlots: { customRender: 'issue' }
  }
]
export default {
  data() {
    return {
      dataSource: [],
      count: 0,
      first: true,
      materialKey: '',
      materialList: [],
      fetching: false
    }
  },
  props: {
    changeSparepartsList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    changeSparepartsList: {
      handler() {
        this.getData()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    getData() {
      this.dataSource = this.changeSparepartsList
      this.count = this.dataSource.length
      if (this.first) {
        this.$emit('change', this.dataSource)
        this.materialKey = ''
        this.getMaterialItems()
        this.first = false
      }
    },
    onDelete(key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== key)
      this.$emit('change', this.dataSource)
    },
    fetchUser(value) {
      this.materialKey = value
      if (!this.filter) {
        this.fetching = true
        this.getMaterialItems()
      }
    },
    handleChange(value, key, col) {
      const has = this.dataSource.find((res) => res.materialCode === value)
      if (has != undefined) {
        this.$message.warning(this.$t('page_plan_spare_parts_not_choose_same'))
        return
      }
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.key)[0]
      const data = this.materialList.find((res) => res.selctName === value)
      console.log(data)
      if (target) {
        target[col] = value
        if (col === 'material' && data) {
          target[col] = data.code
          target['materialId'] = data.materialId
          target['materialName'] = data.name
          target['materialCode'] = data.code
          target['areaId'] = data.areaId
          target['areaName'] = data.areaName
          target['locationId'] = data.locationId
          target['locationName'] = data.locationName
          target['stockSumNum'] = data.stockSumNum
          target['locationNum'] = data.locationNum
        }
        this.dataSource = newData
        this.materialKey = ''
        this.$emit('change', this.dataSource)
      }
    },
    handleAdd() {
      const { count, dataSource } = this
      const newData = {
        key: count + 'add',
        materialId: '',
        orderCode: '',
        stockSumNum: undefined,
        locationNum: undefined,
        stockOutNum: undefined,
        issue: 0,
        materialCode: '',
        materialName: '',
        stockOutNum: 0
      }
      this.first = false
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
      this.materialKey = ''
      this.getMaterialItems()
    },
    onChangeIssue(value, key){
      const newData = [...this.dataSource];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target['issue'] = value;
        this.dataSource = newData;
      }
    },
    getMaterialItems() {
      const values = {
        keyWord: this.materialKey,
        property: 4,
        typeId: ''
      }
      this.materialList = []
      wmsp
        .getStockMaterial(values)
        .then((res) => {
          if (res && res.length) {
            res.forEach((item) => {
              item.selctName = item.name + '(' + item.areaName + '-' + item.locationName + ')'
              this.materialList.push(item)
            })
          }
          this.fetching = false
        })
        .catch(() => {
          this.fetching = false
        })
    }
  }
}
</script>
